import SupplyPage from "./SupplyPage";

export default SupplyPage;